import { Store } from '@reduxjs/toolkit';
import { getAllMetaTagData } from '../utils/metaTags';
import { weblabsActions } from './slices/weblabs';
import type { AppState } from './store';

/**
 * Initializes the Redux store with data from meta tags.
 * This function should be called before the application renders
 * to ensure the store has the correct initial state.
 *
 * Currently handles:
 * - Weblab treatments from meta tags
 *
 * @param store - The Redux store instance to initialize
 */
export const initializeStore = (store: Store<AppState>) => {
  const metaTagData = getAllMetaTagData();
  if (metaTagData.weblabTreatments) {
    store.dispatch(weblabsActions.setWeblabs(metaTagData.weblabTreatments));
  }
};
